import { useContext } from 'react';
import { TransactionsContext } from '../components/TransactionsProvider';

const useTransactions = () => useContext(TransactionsContext);

export default useTransactions;
